'use client';

export type ShareBuilder = (params: {
  origin: string;
  projectId?: string | null;
  nodeId: string;
}) => string;

const SHARE_BUILDERS = new Map<string, ShareBuilder>();

export function registerShareBuilder(id: string, builder: ShareBuilder) {
  SHARE_BUILDERS.set(id, builder);
}

export function getShareBuilder(id?: string | null): ShareBuilder | undefined {
  if (!id) return undefined;
  return SHARE_BUILDERS.get(id);
}


